import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { UserRole } from '../interfaces/user';

// Intake is off per tenant (ClientFeature 'intake') and never for consultants.
// Same terminal fallback as DashboardEnabledGuard: '/users/me' has no role gate.
@Injectable({
  providedIn: 'root'
})
export class IntakeEnabledGuard {

  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.user.pipe(
      take(1),
      map(user => {
        const role = user?.user_to_client?.role;
        const allowed = !!user?.intake_enabled && (role === UserRole.ADMIN || role === UserRole.STAFFER);
        return allowed ? true : this.router.createUrlTree(['/users/me']);
      }),
    );
  }
}
